import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79fb1cd3"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=79fb1cd3&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79fb1cd3')) {
      api.createRecord('79fb1cd3', component.options)
    } else {
      api.reload('79fb1cd3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=79fb1cd3", function () {
      api.rerender('79fb1cd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/centricOS-local-menu-group-permissions/index.vue"
export default component.exports